// extracted by mini-css-extract-plugin
export var footer = "_oz-5";
export var fulfillmentInput = "_oz-0";
export var shipDateInput = "_oz-1";
export var shipmentModal = "_oz-2";
export var shipmentModalContent = "_oz-3";
export var tableContainer = "_oz-4";